module.exports = __webpack_public_path__ + "img/datacenter.29aee35.png";